import Category from "./Category";

export default class Note {
    noteCategory: Category|undefined;

    id = null;
    title = "";
    content = "";
    favorites = false;
    color = 'FFFFFF';
    preview = "";
    media = [];
    tags = [];
    createdAt = 0;
    updatedAt = 0;
}